export default {
  parameter: {
    label: 'Parameters for Recording',
    describe:
      'Customize commonly used game screen recording adjustment parameters to improve the editing efficiency of screen recording projects.',
    table: {
      listEmpty: {
        describe:
          'You don’t have parameters for recording yet. Add common parameters for reuse when creating a screen recording project.',
        create: 'Building up my default parameter list now!',
      },
      batch: {
        delete: 'Delete {num} Parameters for Recording',
        delete1: 'Delete this Parameters for Recording',
        describe:
          "The screen recording project will not be affected after deletion. This can't be undone. Are you sure to delete?",
      },
      isRealized: 'Parameter Status',
      notParameter:
        'Undefined parameters will not be displayed on the screen recording editing page.',
      implemented: 'Defined',
      noImplemented: 'Undefined',
      isDelete:
        "Removal of parameters not defined in Unity can't be undone. Are you sure to delete?",
      minValue: 'Minimum',
      maxValue: 'Maximum',
      name: 'Parameter Name',
      operations: 'Operations',
      note: 'Description',
      type: 'Parameter Type',
      content: 'Options',
      defaults: 'Defaults',
      updatetime: 'Updated Time',
      operation: {
        edittips: 'Edit',
        copytips: 'Copy',
        deletetips: 'Delete',
      },
    },
    edit: {
      plementedTips:
        'The parameters are defined in Unity. The following contents cannot be modified. After modifying the parameters, you need to develop the plug-in to refresh and view the project information, otherwise the parameter modification may fail',
      notModifiable:
        'The parameters are defined, and the following contents cannot be modified',
      table: {
        type: 'Please select parameter type',
        duplicateName:
          'The parameter name cannot be the same as the existing parameter name',
        maxInput: 'Input at most {num} characters',
        correctValue:
          'Please enter the correct value range. The default value is within this range',
        sort: 'Sort',
        content: 'Content',
        operation: 'Operations',
        add: 'Add Option',
      },
      record: 'Edit Parameter for Recording',
      name: 'Parameter Name',
      note: 'Description',
      type: 'Parameter Type',
      content: 'Options',
      preview: 'Preview',
      placeholder: {
        name: 'Please input Parameter Name',
        description: 'Please input Description',
        defaults: 'Please input Defaults',
      },
    },
    input: {
      tips: 'Please enter the most {size} value',
      unlimitedTips: 'Unlimited',
      limitTips: 'Limited',
      small: 'Small',
      large: 'Large',
      minValue: 'Minimum',
      maxValue: 'Maximum',
    },
    new: 'Create Parameter for Recording',
    select: {
      single: 'Radio',
      checkbox: 'Checkbox',
      radio: 'Single Selection Dropdown',
      multi: 'Multiple Selection Dropdown',
      numvalue: 'Value',
    },
    filter: {
      placeholder: 'Search Parameter Name',
    },
    create: {
      new: 'Create Parameter for Recording',
      name: 'Parameter Name',
      note: 'Description',
      type: 'Parameter Type',
    },
  },
}
